"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["onDark"];
/**
 * Reusable logo which can be used across the Common Ground projects.
 */

var NLXLogo = function NLXLogo(_ref) {
  var onDark = _ref.onDark,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var color = onDark === true ? '#ffffff' : '#6C757D';
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 56 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.423 14.254a3.044 3.044 0 0 0 2.358 1.314 2.425 2.425 0 0 0 1.708-.739 2.434 2.434 0 0 0 .685-1.733 1.844 1.844 0 0 0-.272-1.089l-3.398-3.635 3.514-4.157c.18-.347.269-.733.26-1.123a2.359 2.359 0 0 0-.618-1.754 2.35 2.35 0 0 0-1.694-.76 3.073 3.073 0 0 0-2.618 1.35l-2.381 2.999-2.41-3A3.073 3.073 0 0 0 42.94.58a2.35 2.35 0 0 0-1.694.76 2.359 2.359 0 0 0-.618 1.753c-.01.39.081.778.266 1.123l3.514 4.157-3.404 3.635a1.884 1.884 0 0 0-.26 1.089 2.425 2.425 0 0 0 2.393 2.472 3.056 3.056 0 0 0 2.357-1.314l2.474-3.185 2.456 3.185z",
    fill: "#FEBF24"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.767 21.861a2.464 2.464 0 0 0 2.468-2.437 2.493 2.493 0 0 0-2.468-2.472h-7.779V3.202A2.62 2.62 0 0 0 26.37.579a2.62 2.62 0 0 0-2.618 2.623v16.036c-.004.697.27 1.367.762 1.86.492.493 1.16.768 1.856.763h10.397zM0 19.238a2.613 2.613 0 0 0 .763 1.858c.492.493 1.16.768 1.855.765a2.604 2.604 0 0 0 1.855-.765 2.613 2.613 0 0 0 .763-1.858V8.783l8.056 6.223v4.232a2.62 2.62 0 0 0 2.618 2.623 2.62 2.62 0 0 0 2.618-2.623V3.202A2.62 2.62 0 0 0 15.91.579a2.62 2.62 0 0 0-2.618 2.623v5.094l-9.218-7.19A2.407 2.407 0 0 0 2.468.579 2.534 2.534 0 0 0 0 3.126v16.112z",
    fill: color
  })));
};

NLXLogo.propTypes = {
  onDark: _propTypes.bool
};
NLXLogo.defaultProps = {
  onDark: false
};
var _default = NLXLogo;
exports["default"] = _default;